<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="状态">
        <el-select v-model="status" placeholder="状态" clearable>
          <el-option label="待审核" :value="1"></el-option>
          <el-option label="通过" :value="2"></el-option>
          <el-option label="拒绝" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="name" placeholder="名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
        <el-button type="success" @click="addNew">新增</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #handler="{ row }">
        <div>
          <el-button type="primary" size="small" @click="toD(row)"
            >详情</el-button
          >
          
        </div>
      </template>
    </auto-table>

  </div>
</template>

<script>

export default {
  data() {
    return {
      DataList: [],
      Option: [
        { name: "名称", value: "club_name" },
        { name: "城市", value: "city" },
        { name: "成员", value: "total_members" },
        { name: "发布活动", value: "total_activities" },
        { name: "添加时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: "",
      name: "",
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
  toD(row){
    this.$router.push({ name: "clubDetails", query: { id: row.id } });
  },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/shared/club/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          status: this.status,
          name: this.name || null,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>